import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getCustomerPackageOfferLog } from "../../../services/CustomerPackageOffer/CustomerPackageOffer";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ButtonLink from "../../../ButtonLink";
import { getStoreLocalData, getUserData } from "../../../utils/localStorage";

const { innerWidth: width, innerHeight: height } = window;

const AllCustomerPackageOfferLog = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { brandId, storeId, storeCustomerId, item,customerData } = location.state || {};

  const { userProfileRole } =
      getUserData();
      const { storeLocalData } = getStoreLocalData();
  const userRole = userProfileRole;
  const [loading, setLoading] = useState(false);

  const formatDateLedger = (dateString) => {
    const parsedDate = new Date(dateString.replace("Z", ""));

    return parsedDate.toLocaleString("en-GB", {
      month: "2-digit",
      day: "2-digit",
      year: "2-digit",
      hour12: true,
    });
  };

  const [customerPackageOfferLogData, setCustomerPackageOfferLogData] =
    useState([]);

  const fetchCustomerPackageOfferLogList = () => {
    getCustomerPackageOfferLog(brandId, storeId, item.id)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setCustomerPackageOfferLogData(Res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchCustomerPackageOfferLogList();
  }, []);

  const ledgerModeData = {
    DEFAULT: "#a5faf0",
  };

  const renderCardItem2 = () => {
    return customerPackageOfferLogData.map((item) => {
      const ledgerModeColor = ledgerModeData.DEFAULT;
      return (
        <div
          className="flex-1 flex flex-row mx-2 justify-content-between"
          style={{ backgroundColor: `${ledgerModeColor}` }}
        >
          <p className="flex-1 text-lg font-medium text-center border-1 p-1">
            {formatDateLedger(item.createdDate)}
          </p>
          <p className="flex-1 text-lg font-medium text-center border-1 p-1">
            {item.orderInvoiceNo}
          </p>
          <p className="flex-1 text-lg font-medium text-center border-1 p-1">
            {storeLocalData?.currencySymbol} {item.offerApplyOn}
          </p>
          <p className="flex-1 text-lg font-medium text-center border-1 p-1">
            {storeLocalData?.currencySymbol} {item.discount}
          </p>
          <p className="flex-1 text-lg font-medium text-center border-1 p-1">
            {!item.processed ? (
              <img
                src={
                  "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                }
                style={{
                  width: 20,
                }}
              />
            ) : (
              <img
                src={
                  "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                }
                style={{
                  alignSelf: "center",
                  
                  width: 20,
                }}
              />
            )}
          </p>
          <p className="flex-1 text-lg font-medium text-center border-1 p-1">
            <i
              onClick={() =>

              userRole === "BY_ADMIN" || userRole === "BY_SUB_ADMIN_USER"
            ? navigate("/OrdersGarmentInfo", {
                state: {
                  storeIdValue: storeId,
                  bookingOrderId: item.orderId,
                    storeCustomerId: storeCustomerId,
                    navigateThrough: 'GoBack'
                },
              })
            :  navigate("/OrdersGarmentInfo", {
                  state: {
                    bookingOrderId: item.orderId,
                    storeCustomerId: storeCustomerId,
                    navigateThrough: 'GoBack'
                  },
                })
              }
              className="pi pi-eye"
              style={{
                fontSize: "20px",
                cursor: "pointer",
                color: "#2B70D7",
              }}
            ></i>
          </p>
        </div>
      );
    });
  };

  let rows = "";

  customerPackageOfferLogData.forEach((entry) => {
    rows += `
    <div class="table-head">
      <div class="table-cell-head">${formatDateLedger(entry.createdDate)}</div>
      <div class="table-cell-head">{storeLocalData?.currencySymbol} ${entry.orderInvoiceNo}</div>
      <div class="table-cell-head2">{storeLocalData?.currencySymbol} ${entry.offerApplyOn}</div>
      <div class="table-cell-head">{storeLocalData?.currencySymbol} ${entry.discount}</div>
      <div class="table-cell-head2">${entry.processed ? "YES" : "NO"}</div>
    </div>`;
  });

  const offerName = item.brandPackageOffer?.name?.replace(/_/g, " ");

  const customerName = customerData

  const subscriptionDate = formatDateLedger(item.createdDate);

  const validToDate = formatDateLedger(item.validTo);

  const downloadPDF = (type) => {
    const doc = new jsPDF("landscape");
    const logoImg = new Image();

    // Set title of the document
    doc.setFontSize(20);
    doc.text(`Subscription - ${offerName} - Ledger`, 100, 20);
    doc.text(`Customer Name - ${customerName}`, 20, 35);
    doc.text(`Subscription Date - ${subscriptionDate}`, 20, 45);
    doc.text(`Subscription End Date - ${validToDate}`, 20, 55);

    // Format the table data from customerLedger
    const tableData = customerPackageOfferLogData.map((item) => {
      const ledgerModeColor = ledgerModeData.DEFAULT;
      // Format the particulars based on ledgerMode
      return [
        formatDateLedger(item.createdDate), // Date
        item.orderInvoiceNo,
        item.offerApplyOn,
        item.discount,
        item.processed ? "Closed" : "Open",
      ];
    });

    // Define table headers
    const tableHeaders = ["Date", "Bill No.", "Discount Applied On", "Discount", "Status"];

    // Generate the table using autoTable
    doc.autoTable({
      head: [tableHeaders],
      body: tableData,
      startY: 65, // Start position for the table
      theme: "grid",
      styles: {
        fontSize: 10,
      },
    });

    // Handle either print or download based on the `type` argument
    if (type === "print") {
      // Create blob URL and open it in a new window for printing
      const blob = doc.output("blob");
      const blobURL = URL.createObjectURL(blob);
      const printWindow = window.open(blobURL);
      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print();
        };
      }
    } else {
      let date = new Date();
      // Save as PDF file
      doc.save(
        `Subscription-${offerName}-Ledger-${Math.floor(
          date.getTime() + date.getSeconds() / 2
        )}`
      );
    }
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Subscription-package-info")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Consumer Discount
              </p>
            </div>
          </div>

          <div className="flex justify-content-center align-items-center">
            <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
              <img
                onClick={() => downloadPDF("download")}
                src={"images/file.png"}
                style={{
                  width: height < 600 ? 25 :30,
                }}
              />
            </div>
            <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
              <img
                onClick={() => downloadPDF("print")}
                src={"Icons/printer.png"}
                style={{
                  width: height < 600 ? 25 :30,
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-row py-1 mx-2 justify-content-between">
        <p className="flex-1 text-lg font-medium text-center">Date</p>


        <p className="flex-1 text-lg font-medium text-center">Bill No.</p>
        <p className="flex-1 text-lg font-medium text-center">Discount Apply On</p>
        <p className="flex-1 text-lg font-medium text-center">Discount</p>

        <p className="flex-1 text-lg font-medium text-center">Status</p>
        <p className="flex-1 text-lg font-medium text-center">View</p>
      </div>
      {renderCardItem2()}
      <ButtonLink />
    </div>
  );
};

export default AllCustomerPackageOfferLog;
